import { Snackbar } from "@mui/material";
import styled from "styled-components";

export const SnackbarCustom = styled(Snackbar)``;
